export default {
  /*获取所有的酒店活动列表*/
    UPDATEACTIVITYLIST  (state,activityList) { state.ActivityList = activityList; },
  /*已过期酒店活动数量*/
    UPDATEEXPIREDACT  (state,expired) { state.ExpiredActivity = expired; },
  /*正在进行中的酒店活动数量*/
    UPDATEUDERWAYACT  (state,underway) { state.UnderwayActivity = underway; },
  /*酒店活动总数量*/
    UPDATETOTALACT  (state,total) { state.TotalActivity = total; },

  /*展示总信息条目数*/
    UPDATETOTALACCOUNT  (state,total) { state.TotalAccount = total; },
  /*展示符合搜索条件的信息条目数*/
    UPDATESEARCHEDTOTAL (state,showTotal) { state.SearchedTotal = showTotal; },
  /*符合条件的酒店列表*/
    UPDATEHOTELLIST (state,hotelList) { state.HotelList = hotelList; },
  /*右侧广告栏推荐*/
    UPDATERIGHTADVERTIE (state,hotelRight) { state.HotelRight = hotelRight; },
  /*右侧广告栏新增酒店*/
   UPDATEHOTELRIGHTNEW (state,hotelRightNew) { state.HotelRightNew = hotelRightNew; },
  /*热门酒店*/
    UPDATEHOTHOTEL (state,hotelOther) { state.HotelOther = hotelOther; },
  // 品牌馆专项
    UPDATEBRANDINFO(state,brandInfo) { state.BrandInfo = brandInfo; },

  /*获取酒店、民宿、景首字母*/
    UPDATESEARCHINITIAL(state,titleInitial) { state.SearchInitialList = titleInitial; },
  /*获取酒店、民宿、景区基本信息*/
    UPDATEBASICINFO (state, basicInfo) { state.DisplayBasicInfo = basicInfo; },
  /*获取酒店房型信息*/
    UPDATEROOMTYPE (state, roomType) { state.DisplayRoomType = roomType; },
  /*获取酒店、民宿、景区日历信息*/
    UPDATECALENDARINFO (state, calendarInfo) { state.DisplayCalendarInfo = calendarInfo; },
  /*获取酒店、民宿、景区评论信息*/
    UPDATECOMMENTINFO (state, commentInfo) { state.DisplayCommentInfo = commentInfo; },
  /*获取不同等级的评论*/
    UPDATECOMMENTLIST (state, commentInfo) { state.CommentsListByRate = commentInfo; },
  /*获取不同等级的评论*/
    UPDATECOMMENTNUM (state, totalAccount) { state.CommentTotalNum = totalAccount; },
  /*获取酒店、民宿会议室信息*/
    UPDATEMEETINFO (state, commentInfo) { state.DisplayMeetInfo = commentInfo; },
  // 获取品牌馆活动信息
    UPDATEACTIINFO (state, actiInfo) { state.DisplayActiInfo = actiInfo; },
  // 获取品牌馆套餐信息
    UPDATERARYINFO (state, raryInfo) { state.DisplayRaryInfo = raryInfo; },
  // 获取品牌馆餐饮信息
    UPDATERESTAURANTINFO (state, restaurantInfo) { state.DisplayRestaurantInfo = restaurantInfo; },
  /*获取周围酒店信息*/
    UPDATERANGEINFO (state, rangeInfo) { state.DisplayRangeInfo = rangeInfo; },
  /*获取酒店、民宿房型信息*/
    UPDATEROOMINFO (state, roomInfo) { state.DisplayRoomInfo = roomInfo; },
  /*获取民宿活动信息*/
    UPDATEHOMESTAYACT (state, homestayActi) { state.DisplayHomestayInfo = homestayActi; },
  /*获取加入购物车的起止时间*/
    UPDATESHOPTIME (state, shopCart) { state.DisplayShopCart = shopCart; },
  /*酒店详情页-》附近酒店*/
    UPDATERANGEHOTEL (state, rangeHotel) { state.DisplayRangeHotel = rangeHotel; },
  /*景区详情页-》附近热门酒店*/
    UPDATENEARHOTEL(state, nearHotHotel) { state.DisplayNearHotHotel = nearHotHotel; },
  /*景区详情页-》附近热门民宿*/
    UPDATENEARHOTHOMESTAY(state, nearHotHomestay) { state.DisplayNearHotHomestay = nearHotHomestay; },
  /*景区详情页-》同级别的酒店*/
    UPDATEPEERHOTEL(state, peerHotel) { state.DisplayPeerHotel = peerHotel; },
  /*景区门票*/
    UPDATESCENICTICKET(state, scenicTickets) { state.DisplayScenicTicket = scenicTickets; },
  /*获取民宿房间或活动简介*/
    UPDATEHOTELACTIVITIES(state,activityDetail) { state.GetActivityInfo = activityDetail; },
  /*获取酒店活动详情*/
    UPDATESHOPTARGETINFO(state,shopNameInfo) { state.ShopTargetInfo = shopNameInfo; },
  /*获取民宿房型详情*/
    UPDATESHOPROOMARR(state,roomArr) { state.ShopRoomArr = roomArr; },
  /*获取民宿活动详情*/
    UPDATESHOPACTISARR(state,actiArr) { state.ShopActisArr = actiArr; },
  /*获取更改后的民宿活动/民宿房间价格*/
    // UPDATEHOMESTAYPRICE(state,newPrice) { state.ShopNewPrice = newPrice; },
  /*获取购物车采购商信息*/
    UPDATESHOPTRAVELINFO(state,travelInfo) { state.ShopTravelInfo = travelInfo; },
  /*获取民宿预订天数信息*/
    UPDATESTAYNIGHTNFO(state,nightNum) { state.StayNightInfo = nightNum; },

  /*获取首页搜索的行政区划信息*/
    UPDATEBLOCKLIST(state,blockConditionLists) { state.BlockConditionList = blockConditionLists; },

  /*获取其他可供选择的景区门票*/
   UPDATESCENICOPTIONS(state,otherTickets) { state.ScenicTicketsOpt = otherTickets },
   UPDATESCENICROUTER(state,routerId) { state.RouterId = routerId; },

  /*获取地图页面的基本展示信息*/
   UPDATEBASICMAP(state,basicInfo) { state.MapBasicInfo = basicInfo; },
   /*获取搜索页面显示的热门城市*/
    UPDATEHOTCITY(state,hotCity) { state.TopOfTheTown = hotCity; },
   /*获取搜索按首字母展现城市列表*/
    UPDATETCITYINITIAL(state,cityInitial) { state.CityByInitial = cityInitial; },
}
